import accountService from './account.service';
import activityService from './activity.service';
import configService from './config.service';
import globalService from './global.service';
import kpiSetService from './kpiSet.service';
import licenseService from './license.service';
import machineService from './machine.service';
import machineClassService from './machineClass.service';
import materialService from './material.service';
import materialClassService from './materialClass.service';
import operatorService from './operator.service';
import reportDefinitionService from './reportDefinition.service';
import reportDefinitionParameterService from './reportDefinitionParameter.service';
import reportRecipientService from './reportRecipient.service';
import reportScheduleService from './reportSchedule.service';
import scheduledJobService from './scheduledJob.service';
import shiftService from './shift.service';
import siteService from './site.service';
import transferService from './transfer.service';
import truckService from './truck.service';
import truckModelService from './truckModel.service';
import userService from './user.service';
import notificationRecipientService from './notificationRecipient.service';
import licenseTypeService from './licenseType.service';
import licenseJournalService from './licenseJournal.service';
import manufacturerService from './manufacturer.service';
import machineModelService from './machineModel.service';
import kpiService from './kpi.service';

export {
  accountService,
  activityService,
  configService,
  globalService,
  kpiSetService,
  kpiService,
  licenseJournalService,
  licenseService,
  licenseTypeService,
  machineService,
  machineClassService,
  manufacturerService,
  materialService,
  materialClassService,
  machineModelService,
  operatorService,
  reportDefinitionService,
  reportDefinitionParameterService,
  reportRecipientService,
  reportScheduleService,
  scheduledJobService,
  shiftService,
  siteService,
  transferService,
  truckService,
  truckModelService,
  userService,
  notificationRecipientService
};
